import React, { useContext } from 'react'
import Form from '@/components/Form'
import VotacionInfo from '@/components/VotacionInfo'
import SiteContext from '@/context/SiteContext'

const Steps = ({}) => {
  const sitecontext = useContext(SiteContext)

  return (
    <div>
      {sitecontext.rut ? (
        <>
          <div className="mx-auto text-center md:max-w-screen-sm sm:p-8 p-3">
            <div>
              <h6 className="leading-tight mt-2 mb-0">Resultados para </h6>
              <span className="text-3xl block leading-tight">
                <i className="not-italic underline">{sitecontext.rut}</i>.
              </span>
              <p className="font-sans pb-0">
                ¿Quieres ver otra mesa?{' '}
                <a
                  className="underline text-azul hover:text-black"
                  href="#"
                  onClick={e => {
                    e.stopPropagation()
                    sitecontext.saveRut('')
                    sitecontext.clearData('')
                  }}>
                  Ingresa otro RUT
                </a>
              </p>
            </div>
            {Object.entries(sitecontext.rutdata).length > 0 ? (
              <VotacionInfo info={sitecontext.rutdata} />
            ) : (
              <div>Te estamos buscando, espera un momento, por favor...</div>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="mx-auto md:max-w-screen-sm sm:p-8 p-3">
            <div>
              <h6 className="leading-tight mt-2 mb-0">
                Paso 1 de 2<br />
                <span className="text-3xl block leading-tight">
                  Ingresa tu RUT
                </span>
              </h6>
              <Form />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Steps
